import jwtDecode from "jwt-decode";

import { getRefreshToken } from "services/auth";

export const getStorageItem = (key) => {
  if (typeof navigator !== "undefined" && navigator.cookieEnabled && typeof localStorage !== "undefined") {
    return JSON.parse(localStorage.getItem(key));
  }
  return null;
};

export const getUserInfo = (params) => {
  const data = getStorageItem("user-data");
  if (!data || Object.keys(data).length <= 0) {
    return null;
  }
  return params ? data[params] : data;
};

export const isTokenExpired = () => {
  const token = getToken();
  const currentTime = Date.now() / 1000;
  return token && jwtDecode(token).exp < currentTime;
};

/* Check for refresh token expired */
export const isRefreshTokenExpired = () => {
  const refreshToken = getLocalRefreshToken();
  const currentTime = Date.now() / 1000;
  return jwtDecode(refreshToken).exp < currentTime;
};

export const getNewToken = () => {
  /* eslint-disable-next-line */
  return new Promise(async (resolve, reject) => {
    if (!isRefreshTokenExpired()) {
      const refreshToken = getLocalRefreshToken();
      try {
        const res = await getRefreshToken({
          "X-REFRESH-TOKEN": refreshToken,
        });
        const headers = await res.headers;
        const body = await res.data;
        const normalizeData = await normalizeUserData(headers, body);
        resolve(normalizeData);
      } catch (error) {
        reject(error);
        const { status } = error?.response || {};
        if (status && status === 401) logout();
      }
    } else {
      logout();
    }
  });
};

export const normalizeUserData = (headers, body) => {
  /* eslint-disable-next-line */
  return new Promise(async (resolve, reject) => {
    const auth = headers["authorization"];
    const refresh = headers["x-refresh-token"];
    const clone = { ...body, Authorization: auth, "X-Refresh-Token": refresh };
    try {
      await setStorageItem("user-data", clone);
      await setStorageItem("last-logon-user", { ...clone });
      await setStorageItem("Authorization", auth, "default");
      await setStorageItem("RefreshToken", refresh, "default");
      resolve(clone);
    } catch (error) {
      reject(error);
    }
  });
};

const setStorageItem = (key, data, type) => {
  if (typeof navigator !== "undefined" && navigator.cookieEnabled && typeof localStorage !== "undefined") {
    return localStorage.setItem(key, type === "default" ? data : JSON.stringify(data));
  }
  return null;
};

const logout = async () => {
  await removeStorageItem("user-data");
  await removeStorageItem("Authorization");
  await removeStorageItem("RefreshToken");
  window.location.href = process.env.EJ_APP_CANONICAL_HOST;
};

const removeStorageItem = (key) => {
  if (typeof navigator !== "undefined" && navigator.cookieEnabled && typeof localStorage !== "undefined") {
    return localStorage.removeItem(key);
  }
  return null;
};

export const getToken = () => {
  const tokenFromUserData = getUserInfo("Authorization");
  if (tokenFromUserData) return tokenFromUserData;
  return localStorage.getItem("Authorization");
};

export const getLocalRefreshToken = () => {
  const tokenFromUserData = getUserInfo("X-Refresh-Token");
  if (tokenFromUserData) return tokenFromUserData;
  return localStorage.getItem("RefreshToken");
};
